(function () {
  'use strict';

  var UPSELL_MAP = {
    '59228685172817': { subVariantId: '59226382270545' },
    '59228685205585': { subVariantId: '59226382303313' }
  };

  var STORAGE_KEY = 'grns_upsell_pending_remove';
  var debounceTimer;
  var swapping = false;

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function openCartWhenReady() {
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      if (window.wowcart && typeof window.wowcart.openSlideCart === 'function') {
        clearInterval(interval);
        window.wowcart.openSlideCart();
        // Verify it actually opened after animation; retry once if not
        setTimeout(function () {
          if (!document.body.classList.contains('wow-cart-opened') &&
              window.wowcart && typeof window.wowcart.openSlideCart === 'function') {
            window.wowcart.openSlideCart();
          }
        }, 700);
      }
      if (attempts >= 100) clearInterval(interval);
    }, 100);
  }

  // On page load: complete any pending remove from a previous interrupted swap
  function handlePendingRemove() {
    var pendingVariantId = sessionStorage.getItem(STORAGE_KEY);
    if (!pendingVariantId) return;
    sessionStorage.removeItem(STORAGE_KEY);

    document.documentElement.classList.add('grns-cart-updating');

    fetchCart().then(function (cart) {
      var lineKey = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].variant_id) === pendingVariantId) {
          lineKey = cart.items[i].key;
          break;
        }
      }
      var removePromise = lineKey
        ? fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: lineKey, quantity: 0 })
          })
        : Promise.resolve();

      return removePromise;
    }).then(function () {
      document.documentElement.classList.remove('grns-cart-updating');
      setTimeout(openCartWhenReady, 600);
    }).catch(function () {
      document.documentElement.classList.remove('grns-cart-updating');
      setTimeout(openCartWhenReady, 600);
    });
  }

  function swapVariant(singleVariantId, quantity) {
    var subVariantId = UPSELL_MAP[String(singleVariantId)].subVariantId;
    sessionStorage.setItem(STORAGE_KEY, String(singleVariantId));
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: subVariantId, quantity: quantity, selling_plan: 1252687953 })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          sessionStorage.removeItem(STORAGE_KEY);
          throw new Error(data.description || data.message || 'Add failed');
        }
        return fetchCart().then(function (cart) {
          var lineKey = null;
          for (var i = 0; i < cart.items.length; i++) {
            if (String(cart.items[i].variant_id) === String(singleVariantId)) {
              lineKey = cart.items[i].key;
              break;
            }
          }
          if (!lineKey) { sessionStorage.removeItem(STORAGE_KEY); return; }
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: lineKey, quantity: 0 })
          }).then(function () {
            sessionStorage.removeItem(STORAGE_KEY);
          });
        });
      });
    });
  }

  function refreshDrawer() {
    document.querySelectorAll('.grns-upsell-block').forEach(function (el) { el.remove(); });
    fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (data) {
      if (!data['cart-icon-bubble']) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = data['cart-icon-bubble'];
      var bubble = document.getElementById('cart-icon-bubble');
      var newBubble = tmp.querySelector('#cart-icon-bubble');
      if (bubble && newBubble) bubble.innerHTML = newBubble.innerHTML;
    }).catch(function () {});
    if (window.wowcart && typeof window.wowcart.closeSlideCart === 'function') {
      window.wowcart.closeSlideCart();
      setTimeout(openCartWhenReady, 700);
    }
  }

  function buildUpsellBlock(singleVariantId, quantity) {
    var el = document.createElement('div');
    el.className = 'grns-upsell-block';
    el.innerHTML =
      '<div class="grns-upsell-block__inner">' +
        '<div class="grns-upsell-block__text">' +
          '<span class="grns-upsell-block__title">Upgrade to a subscription</span>' +
          '<span class="grns-upsell-block__sub">Save 12% + receive a free Welcome Kit</span>' +
        '</div>' +
        '<button class="grns-upsell-block__btn" type="button">Upgrade</button>' +
      '</div>';
    el.querySelector('.grns-upsell-block__btn').addEventListener('click', function () {
      if (swapping) return;
      swapping = true;
      var btn = this;
      btn.disabled = true;

      var oldWrapper = document.querySelector('.wow-cart-product-item[data-variant_id="' + singleVariantId + '"]');
      oldWrapper = oldWrapper ? (oldWrapper.closest('.wow-cart-product-item__wrapper') || oldWrapper.parentNode) : null;
      if (oldWrapper) oldWrapper.style.cssText += ';opacity:0;transition:opacity 0.25s ease;pointer-events:none;';
      el.style.cssText += ';opacity:0;transition:opacity 0.25s ease;pointer-events:none;';

      swapVariant(singleVariantId, quantity).then(function () {
        if (typeof gtag === 'function') gtag('event', 'grns_upsell_upgrade', { variant_id: String(singleVariantId) });
        refreshDrawer();
        setTimeout(function () { swapping = false; }, 2000);
      }).catch(function (err) {
        swapping = false;
        console.error('GRNS upsell swap failed:', err);
        if (oldWrapper) oldWrapper.style.cssText = oldWrapper.style.cssText.replace(/opacity:[^;]+;?/g, '').replace(/transition:[^;]+;?/g, '').replace(/pointer-events:[^;]+;?/g, '');
        el.style.cssText = el.style.cssText.replace(/opacity:[^;]+;?/g, '').replace(/transition:[^;]+;?/g, '').replace(/pointer-events:[^;]+;?/g, '');
        btn.disabled = false;
      });
    });
    return el;
  }

  function subVariantsInCart(cart) {
    var inCart = {};
    var subIds = Object.values(UPSELL_MAP).map(function (v) { return String(v.subVariantId); });
    cart.items.forEach(function (item) {
      if (subIds.indexOf(String(item.variant_id)) !== -1) inCart[String(item.variant_id)] = true;
    });
    return inCart;
  }

  function injectDrawer(cart) {
    if (swapping) return;
    document.querySelectorAll('.grns-upsell-block').forEach(function (el) { el.remove(); });
    var subsInCart = subVariantsInCart(cart);
    cart.items.forEach(function (item, index) {
      var map = UPSELL_MAP[String(item.variant_id)];
      if (!map || subsInCart[String(map.subVariantId)]) return;
      var itemEl = document.querySelector('.wow-cart-product-item.index-' + index);
      if (!itemEl) return;
      var wrapper = itemEl.closest('.wow-cart-product-item__wrapper') || itemEl.parentNode;
      if (!wrapper) return;
      wrapper.parentNode.insertBefore(buildUpsellBlock(item.variant_id, item.quantity), wrapper.nextSibling);
    });
  }

  function injectCartPage(cart) {
    if (swapping) return;
    document.querySelectorAll('.grns-upsell-row').forEach(function (el) { el.remove(); });
    var subsInCart = subVariantsInCart(cart);
    cart.items.forEach(function (item, index) {
      var map = UPSELL_MAP[String(item.variant_id)];
      if (!map || subsInCart[String(map.subVariantId)]) return;
      var row = document.getElementById('CartItem-' + (index + 1));
      if (!row) return;
      var cols = row.querySelectorAll('td').length || 5;
      var upsellRow = document.createElement('tr');
      upsellRow.className = 'grns-upsell-row';
      var td = document.createElement('td');
      td.setAttribute('colspan', cols);
      td.className = 'grns-upsell-row__cell';
      td.appendChild(buildUpsellBlock(item.variant_id, item.quantity));
      upsellRow.appendChild(td);
      row.parentNode.insertBefore(upsellRow, row.nextSibling);
    });
  }

  function run() {
    fetchCart().then(function (cart) {
      var hasTarget = cart.items.some(function (i) { return UPSELL_MAP[String(i.variant_id)]; });
      if (!hasTarget) {
        document.querySelectorAll('.grns-upsell-block, .grns-upsell-row').forEach(function (el) { el.remove(); });
        return;
      }
      if (document.querySelector('.wow-cart-product-item')) injectDrawer(cart);
      if (document.querySelector('.cart-items')) injectCartPage(cart);
    });
  }

  function debounceRun() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(run, 80);
  }

  function initObserver() {
    var drawerApp = document.getElementById('wow-cart-drawer-app');
    if (drawerApp) new MutationObserver(debounceRun).observe(drawerApp, { childList: true, subtree: true });
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'class' && document.body.classList.contains('wow-cart-opened')) debounceRun();
      });
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    handlePendingRemove();
    run();
    initObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', run);
})();
